import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AddIcon from '@material-ui/icons/Add';
import IconContainer from 'LegacyWeployDesignLanguage/icons/IconContainer';
import JobCurrentSvg from 'LegacyWeployDesignLanguage/icons/JobCurrentIcon';

import Button from 'WeployDesignLanguage/buttons/Button';

import { CREATE_JOB_PATH, getExternalPath } from '../../../containers/weployer/pathHelpers';

const EmptyCurrentActiveJobsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledIconContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

const StyledHeading = styled.h3`
  font-size: 1.4rem;
  margin-bottom: ${props => props.theme.spacing[1]};
`;

const StyledMessage = styled.span`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

const EmptyCurrentActiveJobs = ({ navigateExternal }) => {
  const handleClick = (event) => {
    event.preventDefault();

    const path = getExternalPath({ pathName: CREATE_JOB_PATH });
    navigateExternal(path);
  };

  return (
    <EmptyCurrentActiveJobsWrapper>
      <StyledIconContainer>
        <IconContainer svg={<JobCurrentSvg />} size={IconContainer.LARGE} />
      </StyledIconContainer>
      <StyledHeading>No current jobs</StyledHeading>
      <StyledMessage>Need help around the office? Post a job for a Weployee!</StyledMessage>
      <Button startIcon={<AddIcon />} onClick={handleClick}>Post a job</Button>
    </EmptyCurrentActiveJobsWrapper>
  );
};

EmptyCurrentActiveJobs.propTypes = {
  navigateExternal: PropTypes.func.isRequired,
};

export default EmptyCurrentActiveJobs;
